var video_viewer_default = {
  "video_player": "_5Qs9R",
  "videoOverlay": "dAI7k",
  "video_container": "Zp-O8"
};
export {
  video_viewer_default as default
};
//# sourceMappingURL=video-viewer-scss.js.map
